import systemgScript from "./systemScript" 
export default class variableScript extends systemgScript{
    constructor(system){
        super(system);
    }

    $Date(){
        var obj = new Date();
        var y = obj.getFullYear();
        var m = obj.getMonth()+1;
        var d = obj.getDate();
        if(m<10)m="0"+m;
        if(d<10)d="0"+d;
        var timeDate = y+'/'+m+'/'+d;
        return timeDate;
    }

    //系统时间
    $Time(){
        var obj = new Date();
        var y = obj.getFullYear();
        var m = obj.getMonth()+1;
        var d = obj.getDate();
        var h = obj.getHours();
        var i = obj.getMinutes();
        var s = obj.getSeconds();
        if(m<10)m="0"+m;
        if(d<10)d="0"+d;
        if(h<10)h="0"+h;
        if(i<10)i="0"+i;
        if(s<10)s="0"+s;
        var timeLocale = y+'/'+m+'/'+d+' '+h+':'+i+':'+s;
        return timeLocale;
    }
    //获取系统时间秒
    $TimeEx(){
        return parseInt(new Date().getTime()/1000);
    }
    //获取本机ip地址
    $localhost(){
        return this.system.$.UserMessage.ip;
    }

    //秒
    $Second(){
        var obj = new Date();
        var s = obj.getSeconds();
        if(s<10)s="0"+s;
        var timeSeconds = s;
        return timeSeconds;
    }

    //分
    $Minute(){
        var obj = new Date();
        var i = obj.getMinutes();
        if(i<10)i="0"+i;
        var timeMinute = i;
        return timeMinute;
    }

    //时
    $Hour(){
        var obj = new Date();
        var h = obj.getHours();
        if(h<10)h="0"+h;
        var timeHour = h;
        return timeHour;
    }

    //日
    $Day(){
        var obj = new Date();
        var d = obj.getDate();
        if(d<10)d="0"+d;
        var timeDay = d;
        return timeDay;
    }

    //月
    $Month(){
        var obj = new Date();
        var m = obj.getMonth()+1;
        if(m<10)m="0"+m;
        var timeMouth = m;
        return timeMouth;
    }

    //年
    $Year(){
        var obj = new Date();
        var y = obj.getFullYear();
        var timeYear = y;
        return timeYear;
    }

    //自1970年1月1日0点到现在消耗的时间 毫秒
    $Curtime(){
        var time = new Date();
        return time.getTime();
    }

    //当前星期几
    $Week(){
        var time = new Date();
        return time.getDay();
    }

    //当前毫秒数  返回当前时间的毫秒
    //"July 21, 1983 01:15:00:526"  返回526
    $MilliSec(){
        var time = new Date();
        return time.getMilliseconds();
    }

    //当前用户级别
    $UserLevel(){
        return this.system.$.userLevel;
    }

    //当前用户名
    $UserName(){
        return this.system.$.userName;
    }
    //获取点方法
    $GetTagsDialog(){
        this.system.tagsDialog.$.create();
        new Promise((resolve) => {
            this.system.tagsDialog.$.show("Test.测试1.tag1.PV",true,true,true,function(tagName){
                resolve(tagName);
            });
        }).then(function (tagName) {
           // {name: "testCase_Tag1.PV", desc: "psAPISDK测试"}
            return tagName.name;
          });
    }
    //系统启动后消耗毫秒
    $Msec(){
        var end_time = new Date();
        return end_time.getTime() -  this.system.$.initialTime;
    }
}


// WEBPACK FOOTER //
// ./src/js/script/js/variableScript.js